export const GCS_BUCKET_URI = 'https://storage.googleapis.com/tiny-texts';

export const homeCategories = [
	'6519604594c1b61a4d62db60',
	'6519604594c1b61a4d62db66',
	'6519604594c1b61a4d62db6c',
	'6519604594c1b61a4d62db6b',
	'6519604594c1b61a4d62db6e',
];
